import styled from 'styled-components'

export const Container = styled.div`
  padding: 12px;
  color: ${props => (props.isDark ? '#ffffff' : '#000000')};
  background-color: ${props => (props.isDark ? '#363535' : '#F4FBFB')};
`

export const SlideContainer = styled.div`
  padding: 12px;
  border-radius: 8px;
  color: ${props => (props.isDark ? '#ffffff' : '#000000')};
  background-color: ${props => (props.isDark ? '#2e2e2e' : '#f1f1f1')};
`
